var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7,8.5h-5.3l1-3.4c0.2-0.6,0.1-1.3-0.2-1.8s-1-0.8-1.5-0.8H12c-0.3,0-0.6,0.2-0.7,0.4L6.7,8.5H4.3c-1,0-1.9,0.9-1.9,2 v9.1c0,1.1,0.9,2,1.9,2h12.8c0.8,0,1.5-0.6,1.8-1.3l2.6-7.4c0.1-0.1,0.1-0.2,0.1-0.3v-2C21.6,9.4,20.7,8.5,19.7,8.5z M4.3,10.5h1.9 v9.1H4.3V10.5z M19.7,12.3l-2.6,7.3H8.2V9.8l4.3-5.4h1.1l-1.5,4.7c-0.2,0.6,0.1,1.1,0.6,1.3c0.1,0,0.2,0.1,0.3,0.1h6.7L19.7,12.3 L19.7,12.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxLike);
export default __webpack_public_path__ + "static/media/bx-like.6e81ae2f8daad2deb9c7b5917fd92b20.svg";
export { ForwardRef as ReactComponent };